import React from "react"
import styled from "styled-components"
import Illust4 from "../asset/Illust4"

const Wrapper = styled.div`
  display: flex;
  height: 208px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 16px;
  background: var(--secondary80, #4282ef);
`

const CardIllust4 = () => {
  return (
    <Wrapper>
      <Illust4 />
    </Wrapper>
  )
}

export default CardIllust4
